var map = {
	"./vip.svg": "A7YL",
	"./vip1.svg": "z4lu"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3Lde";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svgs/svg nonrecursive \.svg$
// module id = 3Lde
// module chunks = 21